/**
 * JS
 */

// Lazy load
import './partials/LazyLoad.js';

// Top menu
import './partials/TopMenuToggle.js';

// Widgets
import './partials/CategoryListWidget.js';

// Elementor hacks
import './partials/ElementorHacks.js';

// Load online course JS, if on that page
if (document.getElementById('playmakers-online-course')) {
  import('./pages/OnlineCourse.js');
}
